import { z } from '../zod';
import {
  CursorPaginationValidationBaseSchema,
  SellerAPICursorPaginationValidationSchema,
  withCursorPaginationValidation,
} from '../shared/cursorPagination';
import { PaginatedListSchema } from '../shared/paginatedList';
import { ProductRoleEnumValidationSchema } from './enum';
import { ProductResponseValidationSchema } from './response';

const productListFilterShape = {
  role: ProductRoleEnumValidationSchema.optional().meta({
    description:
      'Only return products with this role. `orderbump` lists the products you can add to a page as order bumps; `product` lists page products. Omit for both.',
    example: 'orderbump',
  }),
  search: z.string().trim().min(1).max(200).optional().meta({
    description: 'Case-insensitive contains match against the product title and SKU.',
  }),
};

export const ProductListQueryValidationSchema = withCursorPaginationValidation(
  SellerAPICursorPaginationValidationSchema.extend(productListFilterShape),
);

export const ListProductsInputValidationSchema = withCursorPaginationValidation(
  CursorPaginationValidationBaseSchema.extend(productListFilterShape),
);

export type ListProductsInput = z.infer<typeof ListProductsInputValidationSchema>;

export const GetProductsResponseValidationSchema = PaginatedListSchema(
  ProductResponseValidationSchema,
).meta({ description: 'A page of your products, newest first.' });
